import mediator, { ACTIONS } from 'mediator';
import { find, head } from 'lodash';
import findParentLevel from './findParentLevel';
import { findSeatEl } from '../seats/seatFinders';

function seatFinder(seatData) {
  return function(item) {
    let seat = find(seatData, x => x.seat_no === parseInt(item.seat_no, 10));
    if (seat) {
      return findSeatEl(seat) || false;
    } else {
      return false;
    }
  };
}

export default function preselectLevel(currentCartItems, seatData) {
  let toSeatEl = seatFinder(seatData);
  let existingItems = currentCartItems.map(toSeatEl);
  let firstSeatEl = head(existingItems);

  if (firstSeatEl) {
    let level = findParentLevel(firstSeatEl);
    if (level) {
      mediator.publish(ACTIONS.LEVEL_PRESELECTED, level.id);
    }
  }
}



// WEBPACK FOOTER //
// ./src/javascripts/lib/seatmaps/preselectLevel.js